import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import shortid from "shortid";
import { observer } from "mobx-react";
import withStyles from "@framework/src/libs/withStyles";
import withConstants from "@framework/src/libs/withConstants";
import { compose } from "recompose";

import useConstants from "@hooks/useConstants";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Container from "@material-ui/core/Container";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import Avatar from "@material-ui/core/Avatar";

import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";

import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import MenuItem from "@material-ui/core/MenuItem";

import Drawer from "@material-ui/core/Drawer";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";

import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import WorkOutlineOutlinedIcon from "@material-ui/icons/WorkOutlineOutlined";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import CallIcon from "@material-ui/icons/Call";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExploreOutlinedIcon from "@material-ui/icons/ExploreOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import Badge from "@material-ui/core/Badge";
import WebsiteLogin from "./WebsiteLogin";

const WebsiteHeader = compose(observer)(({ ...props }) => {
	const classes = useStyles("Website");

	const headerSubNav = true;
	const businessName = "Barton Creek Child Center";
	const banner = "Now Enrolling for 2024 – 2025!";
	const bannerLink = "/linky";

	const logo =
		"https://d1hz0qcu1muexe.cloudfront.net/upload/5f8600302618b119252ff6af/large/7eb97b33fc46167f5bab5699224d49c0HorizontalLogo_Color_1400.webp"; //
	const sticky = false;

	const navAlign = "space-between"; // flex-start / flex-end / center / space-between

	const showPhone = true;
	const showBookingsButton = true;
	const showAccountButton = true;
	const showCartButton = true;

	const button = "Book now";
	const buttonLink = "/booking";

	const buttonSecondary = "Contact us";
	const buttonSecondaryLink = "/wesbite/about-us";

	// drawer

	const anchor = "left";

	const [state, setState] = useState({
		top: false,
		left: false,
		bottom: false,
		right: false,
	});

	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event &&
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setState({ ...state, [anchor]: open });
	};

	const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

	// mobile menu expand

	const [expandedItems, setExpandedItems] = useState({});

	const handleExpandToggle = (index) => {
		// Toggle the expand state for the specific item
		setExpandedItems((prev) => ({
			...prev,
			[index]: !prev[index],
		}));
	};

	// nav

	const navItems = [
		{
			url: "/pros",
			title: "Home",
			subItems: [],
		},
		{
			url: "/pros",
			title: "About us",
			subItems: [],
		},
		{
			url: "/pros/calendar",
			title: "Services",
			subItems: [
				{
					url: "/pros/appointments",
					title: "Guitar lessons",
				},
			],
		},
		{
			url: "/pros/calendar",
			title: "Classes",
			subItems: [
				{
					url: "/pros/appointments",
					title: "Infants 3mo - 12mo",
				},
			],
		},
		{
			url: "/pros/calendar",
			title: "Memberships",
			subItems: [
				{
					url: "/pros/appointments",
					title: "All you can eat nocha",
				},
			],
		},
		{
			url: "/pros",
			title: "Team",
			subItems: [],
		},
		{
			url: "/pros",
			title: "FAQs",
			subItems: [],
		},
		{
			url: "/pros",
			title: "Reviews",
			subItems: [],
		},
		{
			url: "/pros/calendar",
			title: "More",
			subItems: [
				{
					url: "/pros/appointments",
					title: "More",
				},
				{
					url: "/pros/class-schedule",
					title: "Pages",
				},
				{
					url: "/pros/channels",
					title: "They",
				},
				{
					url: "/pros/calendar-settings",
					title: "Want here that exceed 8 items?",
				},
			],
		},
	];

	// popper

	const [openMenus, setOpenMenus] = useState(navItems.map(() => false));
	const anchorRefs = useRef([]);

	const handleHoverEnter = (index) => {
		setOpenMenus((prev) => {
			const newState = [...prev];
			newState[index] = true;
			return newState;
		});
	};

	const handleHoverLeave = (index, event) => {
		const isLeavingButton = anchorRefs.current[index]?.contains(
			event.relatedTarget
		);
		const isLeavingPopper = anchorRefs.current[
			index + navItems.length
		]?.contains(event.relatedTarget);

		if (isLeavingButton || isLeavingPopper) {
			return;
		}

		setOpenMenus((prev) => {
			const newState = [...prev];
			newState[index] = false;
			return newState;
		});
	};

	// Login

	const [openLoginDialogDialog, setOpenLoginDialogDialog] = useState(false);

	const handleLoginDialogClick = () => {
		setOpenLoginDialogDialog(true);
	};

	return (
		<>
			<WebsiteLogin open={openLoginDialogDialog} />
			<div
				className={
					sticky
						? `${classes.headerBar} ${classes.headerBarSticky}`
						: `${classes.headerBar} ${classes.headerBarStatic}`
				}
			>
				{banner && (
					<div className={classes.banner}>
						<Container maxWidth="lg">
							<Box component={"a"} href={bannerLink} fontWeight={600}>
								{banner}
							</Box>
						</Container>
					</div>
				)}
				<Container maxWidth="lg">
					<div className={classes.headerToolbar}>
						<Box
							display={{ xs: "block", md: "none" }}
							position={"absolute"}
							left={8}
						>
							<IconButton
								edge="start"
								color="inherit"
								aria-label="menu"
								onClick={toggleDrawer(anchor, true)}
							>
								<MenuIcon />
							</IconButton>
						</Box>

						<Box display={{ xs: "block", md: "none" }}>
							<Box
								display={"flex"}
								alignItems={"center"}
								component={"a"}
								href="/"
								alt={businessName}
								aria-label={businessName}
								fontSize={20}
								fontWeight={700}
								maxWidth={250}
								textAlign={"center"}
							>
								{logo ? (
									<Avatar
										alt={businessName}
										src={logo}
										classes={{
											img: classes.headerLogo,
											root: classes.headerLogo,
										}}
									/>
								) : (
									businessName
								)}
							</Box>
						</Box>

						<Box
							display={{ xs: "none", md: "flex" }}
							component={"a"}
							href="/"
							alt={businessName}
							aria-label={businessName}
							fontSize={24}
							fontWeight={700}
						>
							{logo ? (
								<Avatar
									alt={businessName}
									src={logo}
									classes={{
										img: classes.headerLogo,
										root: classes.headerLogo,
									}}
								/>
							) : (
								businessName
							)}
						</Box>

						<Box
							display={{ xs: "flex", md: "none" }}
							position={"absolute"}
							right={8}
							style={{ gap: 4 }}
						>
							{showAccountButton && (
								<IconButton
									color="secondary"
									size="small"
									onClick={handleLoginDialogClick}
								>
									<AccountCircleOutlinedIcon />
								</IconButton>
							)}

							{showCartButton && (
								<IconButton
									color="secondary"
									href="/booking/cart"
									target="_blank"
									size="small"
								>
									<Badge variant="dot" color="error">
										<ShoppingCartOutlinedIcon />
									</Badge>
								</IconButton>
							)}
						</Box>

						<Box
							display={{ xs: "none", sm: "none", md: "block" }}
							flexGrow={1}
						/>

						<Box
							display={{ xs: "none", sm: "none", md: "flex" }}
							alignItems={"center"}
						>
							<Box display={"flex"} alignItems={"center"} style={{ gap: 16 }}>
								{showPhone && (
									<Button
										//variant="contained"
										color="primary"
										disableElevation
										href="tel:8888888888"
										size="large"
										startIcon={<CallIcon />}
									>
										Call (512) 301-4788
									</Button>
								)}
								{buttonSecondary && (
									<Button
										size="large"
										color={"secondary"}
										variant="outlined"
										disableElevation
										href={buttonSecondaryLink}
										//startIcon={<DateRangeOutlinedIcon />}
									>
										{buttonSecondary}
									</Button>
								)}
								{button && (
									<Button
										size="large"
										color={"primary"}
										variant="contained"
										disableElevation
										href={buttonLink}
										endIcon={<ArrowForwardIcon />}
									>
										{button}
									</Button>
								)}

								{/* <div>
									<ButtonBase
										ref={anchorRef}
										aria-controls={open ? "menu-list-grow" : undefined}
										aria-haspopup="true"
										onClick={handleToggle}
										className={classes.profile}
									>
										<Box display={"flex"} alignItems={"center"} p={"4px 8px"}>
											<Avatar
												alt={"First name"}
												src="img"
												imgProps={{ loading: "lazy", decoding: "async" }}
												style={{
													width: 32,
													height: 32,
												}}
											/>

											<Box ml={2} mr={1} fontSize={14} fontWeight={600}>
												Nme
											</Box>

											<ExpandMoreOutlinedIcon />
										</Box>
									</ButtonBase>
								</div> */}
							</Box>

							{(showBookingsButton || showAccountButton || showCartButton) && (
								<>
									<Box px={5} height={36}>
										<Divider orientation="vertical" light />
									</Box>
									{showBookingsButton && (
										<Tooltip
											enterDelay={200}
											title="My bookings"
											arrow
											TransitionComponent={Zoom}
											placement={"bottom"}
										>
											<IconButton
												color="secondary"
												href="/booking/cart"
												target="_blank"
											>
												<DateRangeOutlinedIcon />
											</IconButton>
										</Tooltip>
									)}

									{showAccountButton && (
										<Tooltip
											enterDelay={200}
											title="My account"
											arrow
											TransitionComponent={Zoom}
											placement={"bottom"}
										>
											<IconButton
												color="secondary"
												onClick={handleLoginDialogClick}
											>
												<AccountCircleOutlinedIcon />
											</IconButton>
										</Tooltip>
									)}
									{showCartButton && (
										<Tooltip
											enterDelay={200}
											title="My cart"
											arrow
											TransitionComponent={Zoom}
											placement={"bottom"}
										>
											<IconButton
												color="secondary"
												href="/pros/booking/cart"
												target="_blank"
											>
												<Badge badgeContent={4} color="error">
													<ShoppingCartOutlinedIcon />
												</Badge>
											</IconButton>
										</Tooltip>
									)}
								</>
							)}
						</Box>
					</div>
				</Container>

				{headerSubNav && (
					<Box
						p={"16px 24px"}
						borderBottom={"1px solid rgba(0,0,0,0.1)"}
						borderTop={"1px solid rgba(0,0,0,0.1)"}
						display={{ xs: "flex", sm: "flex", md: "none" }}
						alignItems={"center"}
						style={{ gap: 16 }}
					>
						<Button
							variant="outlined"
							color="secondary"
							disableElevation
							fullWidth
							href="tel:8888888888"
							//startIcon={<CallIcon />}
						>
							Contact us
						</Button>
						<Button
							color={"primary"}
							fullWidth
							variant="contained"
							disableElevation
							href="/website/book"
							//startIcon={<DateRangeOutlinedIcon />}
						>
							Schedule a tour
						</Button>
					</Box>
				)}

				<Box
					py={3}
					borderBottom={"1px solid rgba(0,0,0,0.1)"}
					borderTop={"1px solid rgba(0,0,0,0.1)"}
					display={{ xs: "none", sm: "none", md: "block" }}
				>
					<Container maxWidth="lg">
						<Box
							display={"flex"}
							alignItems={"center"}
							justifyContent={navAlign}
							style={{ gap: 12 }}
						>
							{navItems.map((item, index) => (
								<React.Fragment key={index}>
									<Button
										size="large"
										color="secondary"
										href={item.subItems.length === 0 ? item.url : undefined}
										endIcon={item.subItems.length > 0 ? <ExpandMore /> : null}
										ref={(el) => (anchorRefs.current[index] = el)}
										aria-controls={
											openMenus[index] ? `menu-list-grow-${index}` : undefined
										}
										aria-haspopup="true"
										onMouseEnter={() => handleHoverEnter(index)}
										onMouseLeave={(event) => handleHoverLeave(index, event)}
									>
										{item.title}
									</Button>

									{item.subItems.length > 0 && (
										<Popper
											open={openMenus[index]}
											anchorEl={anchorRefs.current[index]}
											transition
											disablePortal
											placement="bottom-start"
											style={{ zIndex: 1500 }}
											ref={(el) =>
												(anchorRefs.current[index + navItems.length] = el)
											}
											onMouseEnter={() => handleHoverEnter(index)}
											onMouseLeave={(event) => handleHoverLeave(index, event)}
										>
											{({ TransitionProps, placement }) => (
												<Grow
													{...TransitionProps}
													style={{
														transformOrigin:
															placement === "bottom-end"
																? "bottom-end"
																: "bottom-end",
													}}
												>
													<Paper elevation={6} style={{ width: 250 }}>
														<MenuList id={`menu-list-grow-${index}`}>
															{item.subItems.map((subItem, subIndex) => (
																<MenuItem
																	key={subIndex}
																	component="a"
																	href={subItem.url}
																	classes={{ root: classes.menuItemRoot }}
																>
																	{subItem.title}
																</MenuItem>
															))}
														</MenuList>
													</Paper>
												</Grow>
											)}
										</Popper>
									)}
								</React.Fragment>
							))}
						</Box>
					</Container>
				</Box>

				<Drawer
					anchor={anchor}
					open={state[anchor]}
					onClose={toggleDrawer(anchor, false)}
					disableBackdropTransition={!iOS}
					disableDiscovery={iOS}
					ModalProps={{
						BackdropProps: {
							style: {
								backgroundColor: "rgba(182, 192, 205, 0.4)",
							},
						},
					}}
				>
					<div className={classes.list}>
						<List>
							<Box display={{ xs: "block", sm: "block", md: "none" }}>
								<ListItem
									button
									component="a"
									href="/"
									onClick={toggleDrawer(anchor, false)}
									onKeyDown={toggleDrawer(anchor, false)}
								>
									<ListItemText
										className={classes.listItem}
										disableTypography
										primary="My account"
									/>
								</ListItem>

								<ListItem
									button
									component="a"
									href="/"
									onClick={toggleDrawer(anchor, false)}
									onKeyDown={toggleDrawer(anchor, false)}
								>
									<ListItemText
										className={classes.listItem}
										disableTypography
										primary="My bookings"
									/>

									<Badge
										badgeContent="3"
										color="primary"
										overlap="rectangular"
										classes={{
											anchorOriginTopRightRectangular: classes.navBadge,
										}}
									/>
								</ListItem>

								<ListItem
									button
									component="a"
									href="/"
									onClick={toggleDrawer(anchor, false)}
									onKeyDown={toggleDrawer(anchor, false)}
								>
									<ListItemText
										className={classes.listItem}
										disableTypography
										primary="My cart"
									/>
								</ListItem>

								<Divider light />
							</Box>
							{navItems.map((item, index) => {
								const isExpanded = !!expandedItems[index];

								return (
									<React.Fragment key={shortid.generate()}>
										<ListItem
											button
											component="a"
											href={item.subItems.length === 0 ? item.url : undefined}
											onClick={
												item.subItems.length > 0
													? () => handleExpandToggle(index)
													: toggleDrawer(anchor, false)
											}
											onKeyDown={
												item.subItems.length > 0
													? () => handleExpandToggle(index)
													: toggleDrawer(anchor, false)
											}
										>
											<ListItemText
												className={classes.listItem}
												disableTypography
												primary={item.title}
											/>
											{item.subItems.length > 0 &&
												(isExpanded ? <ExpandLess /> : <ExpandMore />)}
										</ListItem>

										{item.subItems.length > 0 && (
											<Collapse in={isExpanded} timeout="auto" unmountOnExit>
												<List component="div" disablePadding>
													{item.subItems.map((subItem, subIndex) => (
														<ListItem
															key={subIndex}
															component="a"
															href={subItem.url}
															onClick={toggleDrawer(anchor, false)}
															onKeyDown={toggleDrawer(anchor, false)}
														>
															{subItem.title}
														</ListItem>
													))}
												</List>
											</Collapse>
										)}
									</React.Fragment>
								);
							})}
						</List>
					</div>
				</Drawer>
			</div>
		</>
	);
});

WebsiteHeader.defaultProps = {};

WebsiteHeader.propTypes = {};

export default React.memo(WebsiteHeader);
